import "./BiomarkersComponent.scss";
import {CommonService} from "../../shared/services";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import commonService from "../../shared/services/common.service";
import {Download} from "@mui/icons-material";
import {Link} from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import React, {useCallback, useEffect, useState} from "react";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {IAPIResponseType} from "../../shared/models/api.model";
import _ from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import SearchComponent from "../../shared/components/search/SearchComponent";
import BiomarkerListTableComponent from "./biomarker-list-table/BiomarkerListTableComponent";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import BiomarkersFiltersComponent from "./biomarkers-filters/BiomarkersFiltersComponent";
import ReorderIcon from "@mui/icons-material/Reorder";
import DialogComponent from "../../shared/components/dialog/dialogComponent";
import FileDragAndDropComponent from "../../shared/components/file-drag-n-drop/FileDragAndDropComponent";
import ChipComponent from "../../shared/components/chip/ChipComponent";

interface BiomarkersComponentProps {

}

const FiltersInitialState: any = {
    search: '',
    sampleTypeObjs: [],
    sampleTypes: [],
    sampleCollectionDeviceObjs: [],
    sampleCollectionDevices: [],
    createdByObjs: [],
    createdByIds: [],
    statuses: [],
    statusesObjs: [],
    startDate: '',
    endDate: ''
}

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['statusesObjs', 'createdByObjs', 'sampleTypeObjs', 'sampleCollectionDeviceObjs'];
const MODULE_NAME = "BiomarkerList"

const BiomarkersComponent = (props: BiomarkersComponentProps) => {
    const [isCSVDownloading, setIsCSVDownloading] = useState(false);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [biomarkerFile, setBiomarkerFile] = useState<File | undefined>(undefined);
    const [isBiomarkerUploading, setIsBiomarkerUploading] = useState<boolean>(false);
    const [istemplateDownloading, setIsTemplateDownloading] = useState<boolean>(false);
    const {
        userList,
        facilityStatusList,
        // sampleTypesList, equipmentTypeList,
        sampleTypeWithCollectionDevices,
    } = useSelector((state: IRootReducerState) => state.staticData);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    useEffect(() => {
        dispatch(setCurrentNavParams("Biomarkers", "Biomarkers"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const downloadCSV = useCallback(() => {
        const payload = {...filterData};
        setIsCSVDownloading(true);
        CommonService._biomarker.downloadBiomarkerCsv(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCSVDownloading(false);
                if (response && response?.data && response?.data?.attachmentUrl) {
                    CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'biomarker.csv', 'csv');
                }
            })
            .catch((error: any) => {
                setIsCSVDownloading(false);
            });
    }, [filterData]);

    const handleCloseBulkBiomarkerModal = useCallback(() => {
        setIsModalOpen(false);
        setIsBiomarkerUploading(false);
        setBiomarkerFile(undefined);
    }, [])

    const handleBiomarkerUpload = useCallback(() => {
        if (!biomarkerFile) {
            CommonService._alert.showToast("Please Attach file", "error");
            return;
        }
        const formData = new FormData();
        formData.append('file', biomarkerFile);
        setIsBiomarkerUploading(true);
        CommonService._biomarker.uploadBulkBiomarker(formData).then((response) => {
            CommonService._communications.TableWrapperRefreshSubject.next({
                moduleName: MODULE_NAME
            })
            CommonService._alert.showToast(response.message || "Upload Biomarker Success", "success");

        }).catch((error) => {
            CommonService._alert.showToast(error?.error || "Failed to upload file", "error");
        }).finally(() => {
            handleCloseBulkBiomarkerModal();
        })
    }, [biomarkerFile, handleCloseBulkBiomarkerModal])
    const handleSelectBiomarkerAttachment = useCallback((file: File[]) => {
        const [selectedFile] = file;
        setBiomarkerFile(selectedFile);
    }, [])

    const handleDownloadTemplate = useCallback(() => {
        setIsTemplateDownloading(true);
        CommonService._biomarker.downloadBulkBiomarkerTemplate().then((response) => {
            CommonService.downloadFile(response?.data?.url, response?.data?.title || 'biomarker_template.xlsx', 'xlsx');
        }).catch(() => {
            commonService._alert.showToast('Something went wrong while downloading template');
        }).finally(() => {
            setIsTemplateDownloading(false);
        })
    }, []);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                startDate: queryParamData.startDate || '',
                endDate: queryParamData.endDate || '',
            };

            if (queryParamData?.statuses?.length) {
                data['statuses'] = queryParamData.statuses.split(',') || [];
            }
            data['statusesObjs'] = facilityStatusList?.filter((item: any) => data['statuses']?.includes(item?.code));

            if (queryParamData?.createdByIds?.length) {
                data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
            }
            data['createdByObjs'] = userList?.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));

            if (queryParamData?.sampleTypes?.length) {
                data['sampleTypes'] = queryParamData.sampleTypes.split(',') || [];
            }
            data['sampleTypeObjs'] = sampleTypeWithCollectionDevices?.filter((item: any) => data['sampleTypes']?.includes(item?.sampleType));

            if (queryParamData?.sampleCollectionDevices?.length) {
                data['sampleCollectionDevices'] = queryParamData.sampleCollectionDevices.split(',') || [];
            }
            // data['sampleCollectionDeviceObjs'] = equipmentTypeList?.filter((item: any) => data['sampleCollectionDevices']?.includes(item?.code));
            const uniqueSampleDevices = commonService.extractCollectionDevicesFromSampleType(queryParamData?.sampleTypes?.split(',') || [], sampleTypeWithCollectionDevices)
            data['sampleCollectionDeviceObjs'] = uniqueSampleDevices;

            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, facilityStatusList, userList, sampleTypeWithCollectionDevices]);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
    }, [filterData]);

    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);

    return (
        <div className={'biomarkers-component screen'}>
            <DialogComponent
                open={isModalOpen}
                direction={"down"}
                title={"Upload Biomarker File"}
                // description={"Description"}
                isShowCancel={false}
                maxWidth={'sm'}
            >
                <>
                    <FileDragAndDropComponent
                        multiple={false}
                        onFilesDrop={(value: any) => {
                            handleSelectBiomarkerAttachment(value);
                        }}
                        acceptedFileTypes={{
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': []
                        }}
                        fileSizeLimitText={"Only XLSX files are allowed"}
                    />
                    {
                        biomarkerFile &&
                        <ChipComponent className={"mrg-bottom-10"} label={biomarkerFile.name} onDelete={() => {
                            setBiomarkerFile(undefined);
                        }}/>
                    }
                    <div className={'select-lab-dialog-action-wrapper'}>
                        <ButtonComponent
                            variant={'outlined'}
                            color={'primary'}
                            handleClick={handleCloseBulkBiomarkerModal}
                        >
                            Cancel
                        </ButtonComponent>
                        <ButtonComponent
                            type={"submit"}
                            isLoading={isBiomarkerUploading}
                            variant={'contained'}
                            color={'primary'}
                            handleClick={handleBiomarkerUpload}
                            disabled={!biomarkerFile}
                        >
                            Submit
                        </ButtonComponent>
                    </div>
                </>
            </DialogComponent>
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search"}
                                placeholder={"Search Biomarker"}
                                id="search_input"
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                <ButtonComponent
                                    type="button"
                                    id="clear_all_filters"
                                    color={"secondary"}
                                    variant={"text"}
                                    fullWidth={false}
                                    className={"clear-all-filters"}
                                    handleClick={clearAllFilters}
                                >
                                    Clear All
                                </ButtonComponent>}
                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {
                                commonService.checkAccess('Biomarker',
                                    'biomarkerCsvDownload', currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"secondary"}
                                    isLoading={isCSVDownloading}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={downloadCSV}
                                    disabled={isCSVDownloading}
                                    startIcon={<Download/>}
                                >
                                    CSV
                                </ButtonComponent>
                            }
                            {
                                commonService.checkAccess("Biomarker", "addBiomarker", currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="bulk_biomarker_btn"
                                    color={"primary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={() => setIsModalOpen(true)}
                                    startIcon={<ReorderIcon/>}
                                >
                                    Bulk Upload
                                </ButtonComponent>
                            }
                            {
                                commonService.checkAccess("Biomarker", "addBiomarker", currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="bulk_biomarker_btn"
                                    color={"secondary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={handleDownloadTemplate}
                                    isLoading={istemplateDownloading}
                                    startIcon={<Download/>}
                                >
                                    Download template
                                </ButtonComponent>
                            }
                            {
                                commonService.checkAccess('Biomarker',
                                    'addBiomarker', currentUser?.userAccessModules) &&
                                <Link to={CommonService._routeConfig.BiomarkerAddRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="add_location_button"
                                        startIcon={<AddIcon/>}
                                    >
                                        New Biomarker
                                    </ButtonComponent>
                                </Link>
                            }
                        </div>
                    </div>
                    <>
                        <BiomarkerListTableComponent
                            isColumnFilterVisible={true}
                            filterData={filterData}
                            moduleName={MODULE_NAME}
                        />
                    </>
                </div>
            </div>
            <DrawerComponent open={showFilterDrawer}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <BiomarkersFiltersComponent filtersData={filterData} onFiltersApply={applyFilters}
                                            clearAllFilters={clearAllFilters}/>
            </DrawerComponent>

        </div>
    );

};

export default BiomarkersComponent;
